/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of documents (patients) to display or load documents */


(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documentlist', {
      restrict: 'E',
      bindings: {
        documents: '<?',
        key: '@?',
        value: '@?'
      },
      template: `
        <table class="table table-striped hidden-xs hidden-sm">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Typ</th>
            <th>Datum</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="document in vm.documents | filter: {active: !false}">
            <td>{{document.documentname}}</td>
            <td>{{document.type}}</td>
            <td>{{document.created | javadate: 'lll'}}</td>
            <td>
              <a href="/routes/pdfreader/{{document._id}}" target="_blank" class="btn btn-primary" uib-tooltip="PDF anzeigen"><i class="fa fa-eye"></i></a>
              <a href="/routes/pdfdownload/{{document._id}}" class="btn btn-primary" uib-tooltip="PDF speichern"><i class="fa fa-download"></i></a>
<!--              <button class="btn btn-danger" ng-really-click="vm.removeDocument(document)" ng-really-message="Wollen sie das Dokument {{document.type}} wirklich l&ouml;schen?"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>-->
            </td>
          </tr>
        </table>

        <div class="hidden-md hidden-lg hidden-xl">
          <div class="row" ng-repeat="document in vm.documents">
            <div class="col-xs-6">{{document.type}}</div>
            <div class="col-xs-6">{{document.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>
            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->
            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in document.flattags">{{tag}}<wbr></span></div>
            <div class="col-xs-12">
               <a href="/routes/pdfreader/{{document.documentid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">
                  <i class="fa fa-eye"></i>
               </a>
               <a href="/routes/pdfdownload/{{document.documentid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">
                  <i class="fa fa-download"></i>
               </a>
            </div>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Document', 'DocumentHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Document, DocumentHelper, vertxEventBusService) {
          let vm = this;
          vm.editDocument = DocumentHelper.editDocument;
          vm.removeDocument = removeDocument;


          vm.$onInit = function () {

            if (angular.isUndefined(vm.documents)) {
              if (angular.isString(vm.key) && angular.isString(vm.value)) {
                vm.documents = Document.$searchMetaBy(vm.key, vm.value);
              } else {
                vm.documents = Document.$search();
              }
            }
          }; // $onInit()


          function removeDocument(doc) {
            doc.active = false;
            doc.$save().$then(function () {
              vm.documents.$refresh();
            });
          }

          const documentsUpdateHandler = function (message) {
            $log.debug('debug: document update received: ', message);
            if (angular.isDefined(vm.document)) {
              vm.documents.$refresh().$then(function () {
                $log.debug('debug: documentlist refreshed documents');
              }, function (error) {
                $log.debug('debug: documentlist refresh documents failed: ', error);
              });
            }
          };

          vertxEventBusService.on('documents.update', {}, documentsUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('documents.update', {}, documentsUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
